export default __webpack_public_path__ + "static/media/outline_book_white_24dp 1 (2).2d05d3ba.svg";